import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  MenuItem,
  InputLabel,
  Select,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get } from "src/utils/networkUtils";
import AddPackDialog from "src/components/packs-admin/AddPackDialog";
import { useSelector } from "react-redux";

export default function UserPacksPage() {
  const [tenant, setTenant] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [userId, setUserId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const tenantsList = useSelector((state) => state.tenant.tenants);

  useEffect(() => {
    if (!tenant) return;
    if (searchParams.has("user_id")) {
      let userId = searchParams.get("user_id");
      setUserId(userId);
      get(
        `/admin/users/${userId}/packs?offset=0&limit=300&tenantId=${tenant}`
      ).then(function (response) {
        setRows(response.packs);
      });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate, tenant]);

  useEffect(() => {
    if (tenantsList && tenantsList.length > 0 && !tenant) {
      const defaultTenant = tenantsList.find((t) => t.isDefaultTenant === true);
      if (defaultTenant) {
        setTenant(defaultTenant.tenantId);
      } else {
        setTenant(tenantsList[0].tenantId);
      }
    }
  }, [tenantsList, tenant]);

  const handleSuccessAddPackDialog = () => {
    window.location.reload(true);
  };
  const handleCloseAddPackDialog = () => {
    setOpenAddDialog(false);
  };
  return (
    <>
      <Helmet>
        <title> User Packs </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            User Packs
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Box sx={{ width: "20%" }}>
            <InputLabel>Tenant</InputLabel>
            <Select
              sx={{ width: "100%" }}
              value={tenant || ""}
              label="Tenant"
              onChange={(e) => {
                setTenant(e.target.value);
              }}
            >
              {tenantsList &&
                tenantsList.map((t) => (
                  <MenuItem key={t.tenantId} value={t.tenantId}>
                    {t.name}
                  </MenuItem>
                ))}
            </Select>
          </Box>
          <Box>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-outline" />}
              onClick={() => setOpenAddDialog(true)}
              sx={{ mr: 2 }}
            >
              Add Pack
            </Button>
          </Box>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Pack ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.packId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.type}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.createdAt}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            variant="outlined"
                            onClick={() =>
                              navigate(
                                `/dashboard/pack-details?pack_id=${row.packId}`
                              )
                            }
                          >
                            View Cards
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <AddPackDialog
        open={openAddDialog}
        onSuccessHandler={handleSuccessAddPackDialog}
        onClose={handleCloseAddPackDialog}
        setLoading={setLoading}
        userId={userId}
      />
    </>
  );
}
